<template>
    <div>
        <div @click="sendEvents">
            <slot></slot>
        </div>
        <v-modal v-if="showModal" @close="showModal = false"
                 size="large"
                 cancelLabel="close">
            <div slot="content">
                <h2 class="stack-m">Hi! This feature isn’t quite ready yet.</h2>
                <p>We’re glad to see it’s something you’re interested in, and will let you know once we’ve put the
                    finishing touches on it.</p>
            </div>
        </v-modal>
    </div>
</template>

<script>
    import vModal from '@/components/modal/v-modal';

    export default {
        name: 'v-fake-door',
        components: {
            vModal,
        },
        props: {
            config: {
                type: [String, Object],
                required: true,
            },
        },
        data() {
            return {
                showModal: false,
            };
        },
        computed: {
            computedConfig() {
                if (this.isObject) {
                    return this.config;
                }
                return {
                    intercom: {
                        name: 'Fake Door',
                        meta: {
                            url: this.$route.fullPath,
                            label: `fd-${this.config}`,
                        },
                    },
                    gtm: {
                        event: 'fakedoor',
                        category: 'Fake Door',
                        action: 'click',
                        label: `fd-${this.config}`,
                    },
                };
            },
            isObject() {
                return typeof this.config === 'object';
            },
        },
        methods: {
            sendEvents() {
                if (this.isObject && (!this.config.intercom || !this.config.gtm)) {
                    throw new Error('v-fake-door: Config object needs to include an intercom and ga objects');
                }
                this.showModal = true;
                this.triggerIntercomEvent(this.computedConfig.intercom);
                this.triggerGTMEvent(this.computedConfig.gtm);
            },
        },
    };
</script>
